export default __webpack_public_path__ + "static/2-e79df40c0c92d5f4276b09131ac62d14.png";